import connectQueryRules from '../connectors/connectQueryRules';
export default connectQueryRules(function QueryRuleContext() {
  return null;
});


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-core/dist/es/widgets/QueryRuleContext.js
// module id = 933
// module chunks = 0 1 2 3 4 5 6 7 8